import MerchantOption from "../../components/MerchantOption/MerchantOption";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { fetchMerchants } from "../../app/voucherSlice";
import { merchantChoice } from "../../app/voucherSlice";
import { useEffect } from "react";
import Loading from "../../components/Loading/Loading";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";


const BuyVoucher = () => {
    const { t } = useTranslation();

    const currentLanguage = i18n.language.slice(0, 2);

    const dispatch = useAppDispatch();
    const merchants = useAppSelector(state => state.voucher.merchants);
    const loading = useAppSelector(state => state.voucher.status.isLoading);
    const status = useAppSelector(state => state.voucher.status.result);

    const error = status.type === "error";
    const errorMessage = status.description;

    useEffect(
        () => {
            dispatch(fetchMerchants());
        },
        [dispatch]
    );

    const selectMerchant = (id: number) => {
        const chosenMerchant = merchants.find(merchant => merchant.id === id);
        dispatch(merchantChoice(chosenMerchant));
    };

    return (
        <section id="buy-voucher" className="container first-section">

            <h1>{t("home.title")}</h1>
            <p>
                {t("home.description")}
                <span>
                    <a href="#how-it-works">&nbsp;{t("home.howItWorks")}</a>
                </span>
            </p>
            <div className="merchants__container">
                {loading && (
                    <Loading content={t("home.loading")} />
                )}

                {!loading && error && (
                    <p className="merchants__error">{errorMessage}</p>
                )}

                {!loading && !error && (
                    merchants.map(merchant => (
                        <MerchantOption
                            key={merchant.id}
                            merchantClass={merchant.classAppend}
                            logo={merchant.logo}
                            name={merchant.name}
                            onChooseMerchant={() => selectMerchant(merchant.id)}
                        />
                    ))
                )}
            </div>
            <div className="more-soon">
                <img src={`assets/illustrations/more-soon-${currentLanguage}.svg`} alt={t("moreSoon")}/>
            </div>
        </section>
    );
};

export default BuyVoucher;
